module.exports = __webpack_public_path__ + "static/media/8-10ft-practice_42x42.464d9a14.svg";